/**
 * UM approval workflow policy names (JWT `PermissionPolicies` claim values).
 * BE policy names are unchanged — UI maps them to Reviewer / Requestor / Super Admin tool roles (TROC-157 / TROC-326).
 */
export const APPROVAL_PERMISSION_POLICIES = {
  REQUEST: 'ApprovalsRequest',
  REVIEW: 'ApprovalsApprove',
  ASSIGN: 'ApprovalsApply',
  /** Admin path for setting up delegation on behalf of another user — TROC-178 */
  DELEGATIONS_ADMIN: 'DelegationsAdmin'
} as const;

export type ApprovalPermissionPolicy = (typeof APPROVAL_PERMISSION_POLICIES)[keyof typeof APPROVAL_PERMISSION_POLICIES];

/** Minimum length for actor justification on approve / reject / assign (matches BE audit rules). */
export const ACTOR_JUSTIFICATION_MIN_LENGTH = 10;
